@if (video) {
  <video
    #videoElement
    class="c-aprimo-video"
    controls
    playsinline
    crossorigin="anonymous"
    [attr.preload]="preload"
    [attr.poster]="poster || null"
    [autoplay]="autoplayEnabled"
  >
    <source [src]="video.videoUrl" type="video/mp4" />
    @for (track of tracks; track track.language) {
      <track
        kind="captions"
        [src]="track.url"
        [srclang]="track.language"
        [label]="track.label"
        [attr.default]="track.isDefault ? '' : null"
      />
    }
  </video>
}
